import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FlexLayoutModule } from "@angular/flex-layout";
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import {MatDialogModule, MatSnackBarModule, MatCardModule, MatIconModule} from '@angular/material';
import { NgxLoadingModule, } from 'ngx-loading';
import { ForumComponent } from '../forum/forum.component';
import { forumRouting } from '../forum/forum.route';
import { ForumhomeComponent } from './forumhome/forumhome.component';
import { AsktovetComponent } from './asktovet/asktovet.component';
import { ForumdetailComponent } from './forumdetail/forumdetail.component';
import { SharedModule } from '../common/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterModule } from '../filter/filter.module';


@NgModule({
    imports: [
      CommonModule,
      FlexLayoutModule,
      FormsModule,
      NgbModule,
      NgxLoadingModule,
      RouterModule,
      forumRouting,
      SharedModule,
      NgxPaginationModule,
      MatDialogModule,
      FilterModule,MatDialogModule,MatSnackBarModule,MatCardModule,MatIconModule
    ],
    declarations: [
        ForumComponent,
        ForumhomeComponent,
        AsktovetComponent,
        ForumdetailComponent,
       
    ],
    })
    export class ForumModule { }
